import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUpload = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M7.35031 9.11L11.5003 4.93V15.23C11.5003 15.51 11.7203 15.73 12.0003 15.73C12.2803 15.73 12.5003 15.51 12.5003 15.23V4.93L16.6503 9.11C16.7503 9.21 16.8803 9.26 17.0003 9.26C17.1203 9.26 17.2503 9.21 17.3503 9.11C17.5503 8.92 17.5503 8.6 17.3503 8.4L12.3503 3.36L12.0003 3L11.6503 3.36L6.65031 8.4C6.46031 8.6 6.46031 8.91 6.65031 9.11C6.85031 9.31 7.16031 9.3 7.36031 9.11H7.35031Z'
      fill=''
    />
    <path
      d='M3.5 15.5C3.77614 15.5 4 15.7239 4 16V18.5C4 18.7761 4.22386 19 4.5 19H19.5C19.7761 19 20 18.7761 20 18.5V16C20 15.7239 20.2239 15.5 20.5 15.5C20.7761 15.5 21 15.7239 21 16V18.5C21 19.3284 20.3284 20 19.5 20H4.5C3.67157 20 3 19.3284 3 18.5V16C3 15.7239 3.22386 15.5 3.5 15.5Z'
      fill=''
    />
  </svg>
);
export default SvgUpload;
